import React, {Fragment, useCallback} from 'react';
import {Helmet} from 'react-helmet-async';
import {useNavigate} from 'react-router-dom';

import {AlertActions, AlertModal} from 'presentation/components';
import {StyledGrid} from 'presentation/components/Grid';
import {FooterMobile} from 'presentation/components/MainFooter/FooterMobile';
import {SignInEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks';
import {useMediaQueries} from 'presentation/pages/private';
import {Header} from 'presentation/pages/public/components';
import {translations} from 'presentation/translations-new';
import {useSteps} from '../hooks';
import {SectionContent, StyledBox} from '../styles';
import {Step1, Step2, Step3, Step4} from './components';
import {PublicFlowEnum} from '../constants/PublicFlowEnum';

const {cancel, exit} = translations['pt-br'].commons;
const {headTitle, headSubtitle, cancelFlowModal} = translations['pt-br'].publicFlow.signUp;

const TOTAL_STEPS = 4;
const STEP_PAGE: Record<number, React.JSX.Element> = {
	1: <Step1 />,
	2: <Step2 />,
	3: <Step3 />,
	4: <Step4 />,
};

export function SignUp() {
	const navigate = useNavigate();
	const {dataHostNameState} = useHostName();
	const {currentStepState} = useSteps(PublicFlowEnum.SIGN_UP);
	const {modalState, setModalState, resetSteps, resetModalState} = useSteps(
		PublicFlowEnum.SIGN_UP,
	);
	const {isTablet} = useMediaQueries();

	const {productName, product} = dataHostNameState;
	const title = `${headTitle} | ${productName}`;

	const SUBTITLE_BY_OPERATOR = headSubtitle[product as keyof typeof headSubtitle];

	const HEADER_SUBTITLE: Record<number, string> = {
		1: SUBTITLE_BY_OPERATOR.step1,
		2: SUBTITLE_BY_OPERATOR.step2,
		3: SUBTITLE_BY_OPERATOR.step3,
		4: SUBTITLE_BY_OPERATOR.step4,
	};

	const handleExitFlow = useCallback(() => {
		resetSteps(PublicFlowEnum.SIGN_UP);
		resetModalState();
		navigate(SignInEnum.SIGN_IN, {state: {goToSignInState: true}});
	}, []);

	const handleCancel = useCallback(() => {
		setModalState(false);
	}, []);

	return (
		<Fragment>
			<Helmet>
				<title>{title}</title>
			</Helmet>

			<StyledGrid.Root>
				<StyledGrid.Item sm={12} md={12} lg={12}>
					<Header
						headerTitle={headTitle}
						headerSubtitle={HEADER_SUBTITLE[currentStepState]}
						totalSteps={TOTAL_STEPS}
						stepType={PublicFlowEnum.SIGN_UP}
					/>
					<SectionContent>{STEP_PAGE[currentStepState]}</SectionContent>
				</StyledGrid.Item>
			</StyledGrid.Root>

			<StyledBox>
				<FooterMobile hideANS={!isTablet} hidePolicy />
			</StyledBox>

			<AlertModal
				variant="info"
				open={modalState}
				onClose={handleCancel}
				headerTitle={cancelFlowModal.headerTitle}
				title={cancelFlowModal.title}
				description={cancelFlowModal.description}
				footerContent={
					<AlertActions
						primaryAction={handleExitFlow}
						primaryText={exit}
						secondaryAction={handleCancel}
						secondaryText={cancel}
					/>
				}
			/>
		</Fragment>
	);
}
